<button class="btn btn-primary btn-sm" (click)="openModal()" style="width: 100%;">{{title}}</button>

<ng-template #PurchaseOrderItemModal>
    <div class="modal-header">
        <h5 class="modal-title">Purchase Order</h5>
        <button type="button" class="btn-close" (click)="purchaseOrderModalRef.close()"></button>
    </div>

    <div class="modal-body">
        <div class="mb-3">
            <label for="purchaseOrderNo" class="form-label">Purchase Order No<span style="color: red;">*</span></label>
            <ng-select (search)="SearchPurchaseOrder($event)" [items]="purchaseOrderList" bindValue="purchaseOrderId"
                [loading]="searchLoading" bindLabel="purchaseOrderNo" [formControl]="PurchaseOrderNo">
            </ng-select>
        </div>
        <div class="mb-3">
            <div class="table-wrapper card">
                <table class="row-border hover table table-bordered com_table" style="width: 100%;">
                    <thead>
                        <tr class="text-dark" style="border-left: 5px solid var(--bs-primary);">
                            <th scope="col" style="width: 20px;"><input type="checkbox"
                                    (change)="onSelectAllCheckboxChange($event)"></th>
                            <th scope="col">Item</th>
                            <th scope="col">Type</th>
                            <th scope="col">Size</th>
                            <th scope="col">Available Qty</th>
                            <th scope="col">Utilized Qty</th>
                            <th scope="col">Qty</th>
                            <th scope="col">Rate</th>
                        </tr>
                    </thead>
                    <tbody id="TemplateListBody">
                        <tr *ngFor="let items of SelectedPurchaseOrderItems">
                            <td style="width: 50px;">
                                <input type="checkbox" [checked]="items.isSelected"
                                    (change)="onSelctionCheckboxChange($event,items)">
                            </td>
                            <td>{{items.itemNo}}</td>
                            <td>{{items.iCategory}}</td>
                            <td>{{items.iSubCategory}}</td>
                            <td>{{items.availableQty}}</td>
                            <td>{{items.utilizedQty}}</td>
                            <td style="width: 120px;">
                                <input type="number" class="form-control form-control-sm" *ngIf="items.isSelected"
                                    [(ngModel)]="items.qty" min="1">
                            </td>
                            <td>{{items.price}}</td>
                        </tr>
                        <tr *ngIf="dataLoading">
                            <td colspan="8">
                                <ngx-skeleton-loader [appearance]="'line'"></ngx-skeleton-loader>
                            </td>
                        </tr>
                        <tr *ngIf="!dataLoading && SelectedPurchaseOrderItems.length === 0">
                            <td colspan="8" class="text-center">No items found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="modal-footer text-end">
        <button class="btn btn-sm btn-primary" [disabled]="isSubmitting || SelectedDetailItems.length === 0" 
                (click)="submitResults()">
            <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1" role="status"
                aria-hidden="true"></span>
            <span>{{ isSubmitting ? 'Submitting...' : 'Submit' }}</span>
        </button>
        <button class="btn btn-sm btn-secondary" (click)="purchaseOrderModalRef.close()">Close</button>
    </div>
</ng-template>
